<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h2><span class="h2-inner">Prologue</span></h2>
<blockquote class=" bq">
<p class=" firstInSection">“I think the New Modellers knead all their dough with ale for I have never seen so many drunk in my life in so such a short a time.”</p>
</blockquote>
<p class="source firstInSection">Sir Samuel Luke, Parliamentary Governor of Newport Pagnell, on seeing troops from the New Model Army for the first time</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?aa0d32f4